import { BRANDING_URL } from '@/utils/brand';
import { useSpring, animated } from '@react-spring/web';

type Props = {
  title?: string;
  message?: string;
};

export default function NotFound(props: Props) {
  const {
    title = 'Produto não encontrado!',
    message = 'Produto não disponível, inativo ou bloqueado. Contate o suporte para mais informações.'
  } = props;

  const springLogoDesktop = useSpring({
    from: { opacity: 0, y: -20 },
    to: { opacity: 1, y: 0 },
    delay: 600,
    config: { tension: 120, friction: 14 }
  });

  const springLogoMobile = useSpring({
    from: { opacity: 0, y: -20 },
    to: { opacity: 1, y: 0 },
    delay: 600,
    config: { tension: 120, friction: 14 }
  });

  const springTitle = useSpring({
    from: { opacity: 0, y: -20 },
    to: { opacity: 1, y: 0 },
    delay: 200,
    config: { tension: 120, friction: 14 }
  });

  const springMessage = useSpring({
    from: { opacity: 0, y: -20 },
    to: { opacity: 1, y: 0 },
    delay: 400,
    config: { tension: 120, friction: 14 }
  });

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <animated.div style={springLogoDesktop} className="my-10">
        <img
          src={`${BRANDING_URL}name-logo.png`}
          alt="Logo na versão desktop"
          className="h-20 hidden max-w-xs sm:block"
        />
      </animated.div>

      <animated.div style={springLogoMobile} className="my-10">
        <img
          src={`${BRANDING_URL}logo.png`}
          alt="Logo na versão mobile"
          className="h-36 sm:hidden"
        />
      </animated.div>

      <animated.div
        style={springTitle}
        className="mb-6 text-2xl font-semibold text-center text-white"
      >
        {title}
      </animated.div>

      <animated.div style={springMessage} className="text-center text-gray-500">
        {message}
      </animated.div>
    </div>
  );
}
